/* === CLAUDE 2026-10-01 #18 :: Page produit – choix couleur/taille, galerie par couleur, ajout au panier === */
(function () {
  function init(root) {
    var variants = JSON.parse(root.querySelector('[data-jp-variants]').textContent);
    var ci = parseInt(root.dataset.colorIndex, 10);
    var gallery = root.querySelector('[data-jp-gallery]');
    var items = Array.prototype.slice.call(gallery.children);
    var cur = root.dataset.cur || '';

    // Groupes de photos par couleur : chaque groupe commence à la photo de la couleur (pastille) et va jusqu'à la couleur suivante
    var starts = {};
    if (ci >= 0) {
      variants.forEach(function (v) {
        var c = v.options[ci];
        if (v.media && starts[c] === undefined) {
          var idx = items.findIndex(function (el) { return el.dataset.mediaId == String(v.media); });
          if (idx > -1) starts[c] = idx;
        }
      });
    }
    var order = Object.keys(starts).sort(function (a, b) { return starts[a] - starts[b]; });
    function groupOf(color) {
      if (starts[color] === undefined) return null;
      var i = order.indexOf(color);
      var from = starts[color];
      var to = i + 1 < order.length ? starts[order[i + 1]] : items.length;
      return items.slice(from, to);
    }
    function showColor(color) {
      var g = groupOf(color);
      if (!g) return;
      var rest = items.filter(function (el) { return g.indexOf(el) === -1; });
      g.concat(rest).forEach(function (el) { gallery.appendChild(el); });
      if (window.matchMedia('(max-width: 989px)').matches) { gallery.scrollTo({ left: 0 }); }
    }

    function selected() {
      var opts = [];
      root.querySelectorAll('input[data-opt-index]:checked').forEach(function (i) { opts[parseInt(i.dataset.optIndex, 10)] = i.value; });
      return opts;
    }
    function money(cents) { var n = cents / 100; return cur + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2 })); }
    function update(changedIndex) {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); });
      var btn = root.querySelector('[data-jp-add]');
      if (!v) { btn.disabled = true; btn.textContent = root.dataset.tSold; return; }
      root.querySelector('[data-jp-variant-id]').value = v.id;
      btn.disabled = !v.available;
      /* === CLAUDE 2026-10-02 #67 :: data-jp-money sur les prix du bouton (affichage € / $) === */
      btn.innerHTML = v.available ? root.dataset.tAdd + ' - <span dir="ltr" data-jp-money="' + v.price + '">' + money(v.price) + '</span>' + (v.compare > v.price ? ' <s dir="ltr" data-jp-money="' + v.compare + '">' + money(v.compare) + '</s>' : '') : root.dataset.tSold;
      /* === /CLAUDE 2026-10-02 #67 === */
      if (ci >= 0) {
        if (changedIndex === ci) showColor(v.options[ci]);
      }
      // tailles épuisées pour la couleur choisie
      root.querySelectorAll('input[data-opt-index]').forEach(function (inp) {
        var oi = parseInt(inp.dataset.optIndex, 10); if (oi === ci) return;
        var test = opts.slice(); test[oi] = inp.value;
        var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return test[i] === undefined || o === test[i]; }); });
        inp.parentNode.classList.toggle('is-out', !ok);
      });
      /* === CLAUDE 2026-10-02 #89 :: l'adresse ne reçoit la variante que lorsque la cliente change une option (pas à l'ouverture) === */
      if (changedIndex !== -1 && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      /* === /CLAUDE 2026-10-02 #89 === */
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[data-opt-index]')) update(parseInt(e.target.dataset.optIndex, 10)); });
    // Onglets (comme sur WordPress) : un onglet toujours ouvert, clic = afficher celui-ci
    root.querySelectorAll('[data-jp-tabs] [role="tab"]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-jp-tabs] [role="tab"]').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        root.querySelectorAll('[data-jp-tabs] [role="tabpanel"]').forEach(function (pn) { pn.hidden = true; });
        t.setAttribute('aria-selected', 'true'); document.getElementById(t.getAttribute('aria-controls')).hidden = false;
      });
    });
    var form = root.querySelector('.jp-pdp__form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = root.querySelector('[data-jp-add]'); var msg = root.querySelector('[data-jp-msg]');
      btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { msg.textContent = res.j.description || res.j.message || 'Error'; return; }
          msg.textContent = '';
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.jp-header__count').forEach(function (el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('jp:cart:added', { detail: { cart: cart, item: res.j } }));
          });
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
    /* === CLAUDE 2026-10-02 #89 :: la page s'ouvre sur la photo principale ; la galerie ne passe à une couleur que si l'adresse contient ?variant= (clic sur une couleur précise) ou quand la cliente choisit une couleur === */
    var jpHadVariant = /[?&]variant=/.test(window.location.search);
    update(-1);
    if (ci >= 0 && jpHadVariant) { var o = selected(); showColor(o[ci]); }
    /* === /CLAUDE 2026-10-02 #89 === */
  }
  /* === CLAUDE 2026-10-02 #91 :: blocs « Available colors » (bouton = choisir la couleur dans la fiche) et « ce produit dans un look » (lu sur la page Shop the look) === */
  function extras() {
    document.querySelectorAll('[data-jp-avc-select]').forEach(function (b) {
      b.addEventListener('click', function () {
        var root = document.querySelector('[data-jp-product]'); if (!root) return;
        var inp = Array.prototype.find.call(root.querySelectorAll('.jp-swatch input'), function (i) { return i.value === b.getAttribute('data-jp-avc-select'); });
        if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        var f = root.querySelector('.jp-pdp__form'); if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    var box = document.querySelector('[data-jp-inlook]'); if (!box || !window.fetch || !window.DOMParser) return;
    var path = function (u) { try { return decodeURI(new URL(u, window.location.origin).pathname).replace(/\/$/, ''); } catch (e) { return u; } };
    var mine = path(box.getAttribute('data-product-url'));
    fetch(box.getAttribute('data-url'), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html'); var body = box.querySelector('[data-jp-inlook-body]'); var n = 0;
      doc.querySelectorAll('.jp-stl__item').forEach(function (item) {
        var prods = Array.prototype.slice.call(item.querySelectorAll('a.jp-stl__prod'));
        if (!prods.some(function (a) { return path(a.getAttribute('href')) === mine; })) return;
        var img = item.querySelector('.jp-stl__img > img'); var title = item.querySelector('.jp-stl__title');
        var look = document.createElement('div'); look.className = 'jp-inlook__look jp-inlook__body';
        var ph = document.createElement('div'); ph.className = 'jp-inlook__photo';
        if (img) { var im = document.createElement('img'); im.src = img.getAttribute('src'); if (img.getAttribute('srcset')) im.srcset = img.getAttribute('srcset'); im.sizes = '(min-width: 990px) 480px, 92vw'; im.alt = img.getAttribute('alt') || ''; im.loading = 'lazy'; ph.appendChild(im); }
        var side = document.createElement('div');
        if (title) { var h = document.createElement('p'); h.className = 'jp-inlook__title'; h.textContent = title.textContent.trim(); side.appendChild(h); }
        var list = document.createElement('div'); list.className = 'jp-inlook__list';
        prods.forEach(function (a) {
          if (path(a.getAttribute('href')) === mine) return;
          var l = document.createElement('a'); l.className = 'jp-inlook__prod'; l.href = a.getAttribute('href');
          var t = a.querySelector('img'); if (t) { var ti = document.createElement('img'); ti.src = t.getAttribute('src'); ti.alt = t.getAttribute('alt') || ''; ti.loading = 'lazy'; l.appendChild(ti); }
          var txt = document.createElement('span'); var nm = a.querySelector('.jp-stl__name'); var pr = a.querySelector('.jp-stl__price');
          if (nm) { var s1 = document.createElement('span'); s1.textContent = nm.textContent.trim(); txt.appendChild(s1); }
          if (pr) { var s2 = document.createElement('span'); s2.dir = 'ltr'; s2.textContent = pr.textContent.trim(); if (pr.getAttribute('data-jp-money')) s2.setAttribute('data-jp-money', pr.getAttribute('data-jp-money')); txt.appendChild(s2); }
          l.appendChild(txt); list.appendChild(l);
        });
        side.appendChild(list); look.appendChild(ph); look.appendChild(side); body.parentNode.insertBefore(look, body); n++;
      });
      if (n) { body.remove(); box.hidden = false; }
    }).catch(function () {});
  }
  /* === /CLAUDE 2026-10-02 #91 === */
  /* === CLAUDE 2026-10-02 #92 :: Assistant taille — lit les tailles écrites dans l'onglet « Size & Fit » (ex. « One size fits 34 to 42 », « S/M fits 34 to 38, M/L fits 40 to 42 », « S (36), M (38) ») et répond avec ces chiffres ; reste masqué si le produit ne donne aucune taille === */
  function sizeAssistant() {
    var box = document.querySelector('[data-jp-sa]'); var fit = document.getElementById('JpTabFit'); if (!box || !fit) return;
    var RNG = /(^|[^\d])(\d{2})\s*(?:to|a|à|au|עד|–|—|-|־)\s*(\d{2})(?!\d)(\s*(?:cm|ס"מ|ס״מ|סמ))?/gi;
    var SINGLE = /(?:^|[^A-Za-z])(XXS|XS|S|M|L|XL|XXL)\s*\((\d{2})\)/g;
    var TOKEN = /(?:^|[^A-Za-z0-9])(XXS|XXL|XS|XL|S\s*\/\s*M|M\s*\/\s*L|T?\d|S|M|L)(?![A-Za-z0-9\/])/g;
    var ranges = [];
    var lines = Array.prototype.map.call(fit.querySelectorAll('p'), function (p) { return p.textContent.replace(/\s+/g, ' ').trim(); });
    lines.forEach(function (ln) {
      ln.split(/[,;،]/).forEach(function (seg) {
        var m; RNG.lastIndex = 0;
        while ((m = RNG.exec(seg))) {
          var a = parseInt(m[2], 10), b = parseInt(m[3], 10);
          if (m[4] || a < 30 || b > 60 || a > b) continue;
          var before = seg.slice(0, m.index + m[1].length);
          var t, last = ''; TOKEN.lastIndex = 0;
          while ((t = TOKEN.exec(before))) { last = t[1]; }
          ranges.push({ label: last.replace(/\s+/g, '').toUpperCase(), a: a, b: b });
        }
      });
      var s; SINGLE.lastIndex = 0;
      while ((s = SINGLE.exec(ln))) { var v = parseInt(s[2], 10); if (v >= 30 && v <= 60) ranges.push({ label: s[1].toUpperCase(), a: v, b: v }); }
    });
    if (!ranges.length) return;
    // noms des tailles affichés sur la page (pour reprendre le libellé du site)
    var norm = function (x) { return String(x).replace(/[^A-Za-z0-9]/g, '').toUpperCase(); };
    var names = {}; var fs = box.closest('fieldset');
    if (fs) fs.querySelectorAll('.jp-size').forEach(function (l) { var i = l.querySelector('input'); var sp = l.querySelector('span'); if (i) names[norm(i.value)] = sp ? sp.textContent.trim() : i.value; });
    var single = ranges.length === 1;
    var count = fs ? fs.querySelectorAll('.jp-size').length : 0;
    ranges.forEach(function (r) { var k = norm(r.label); r.name = k ? (names[k] || names[k.replace(/^T/, '')] || names['T' + k] || r.label) : ''; });
    if (!single && ranges.some(function (r) { return !r.name; })) {
      // tailles sans libellé reconnu : on ne répond que si chaque taille du produit a sa plage, dans l'ordre ; sinon l'assistant reste masqué
      if (ranges.length !== count) return;
      var labels = Array.prototype.map.call(fs.querySelectorAll('.jp-size span'), function (sp) { return sp.textContent.trim(); });
      ranges.forEach(function (r, i) { r.name = labels[i]; });
    }
    // exactitude : si le texte nomme une taille qui n'existe pas dans les tailles du produit, l'assistant reste masqué
    if (!single) { var pageSizes = fs ? Array.prototype.map.call(fs.querySelectorAll('.jp-size span'), function (sp) { return sp.textContent.trim(); }) : []; if (ranges.some(function (r) { return pageSizes.indexOf(r.name) === -1; })) return; }
    ranges.sort(function (x, y) { return x.a - y.a; });
    box.setAttribute('data-ranges', JSON.stringify(ranges));
    var res = box.querySelector('[data-jp-sa-res]'); var d = box.dataset;
    var fill = function (tpl, o) { return tpl.replace(/\{(\w+)\}/g, function (_, k) { return o[k] !== undefined ? o[k] : ''; }); };
    function answer(s) {
      if (single) {
        var r = ranges[0], o = { s: s, a: r.a, b: r.b };
        if (s < r.a) return fill(d.below, o);
        if (s > r.b) return fill(d.above, o);
        if (r.b > r.a && s === r.b) return fill(d.hi, o);
        if (r.b > r.a && s === r.a) return fill(d.lo, o);
        return fill(d['in'], o);
      }
      var lo = ranges[0].a, hi = ranges[ranges.length - 1].b;
      var hit = ranges.filter(function (r) { return s >= r.a && s <= r.b; })[0];
      if (hit) return fill(d.pick, { s: s, label: hit.name });
      if (s < lo) return fill(d.below, { s: s, a: lo, b: hi });
      if (s > hi) return fill(d.above, { s: s, a: lo, b: hi });
      var up = ranges.filter(function (r) { return r.a > s; })[0];
      return fill(d.near, { s: s, label: up.name });
    }
    box.hidden = false;
    var tg = box.querySelector('.jp-sa__toggle'), panel = box.querySelector('.jp-sa__panel');
    tg.addEventListener('click', function () { var open = tg.getAttribute('aria-expanded') === 'true'; tg.setAttribute('aria-expanded', open ? 'false' : 'true'); panel.hidden = open; });
    box.querySelectorAll('[data-jp-sa-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        box.querySelectorAll('[data-jp-sa-size]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        res.textContent = answer(parseInt(b.getAttribute('data-jp-sa-size'), 10));
      });
    });
  }
  /* === /CLAUDE 2026-10-02 #92 === */
  function boot() { document.querySelectorAll('[data-jp-product]').forEach(init); extras(); sizeAssistant(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* === /CLAUDE 2026-10-01 #18 === */